<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import router from "@/router";
export default {
  name: "app",
  components: {},
  provide() {
    const screenWidth = document.body.clientWidth;
    let screenType = "computer";
    if (screenWidth > 1280) {
      screenType = "computer";
    } else if (screenWidth > 1000) {
      screenType = "ipad";
    } else {
      screenType = "mobile";
    }
    return {
      screenType: screenType,
      appModule: this,
    };
  },
  data() {
    return {
      tokenTimeout: null,
      sysname: "", // 补充定义sysname变量
      // 浏览器关闭检测相关变量
      bc: null, // 广播通道实例
      isCurrentTabAlive: true, // 当前标签页是否存活
      tabCount: 1, // 浏览器内标签页数量
      tabId: Math.random().toString(36).slice(2, 9), // 唯一标签页ID
      isPageUnloading: false, // 标记页面是否正在卸载
    };
  },
  created() {
    // 在页面加载时读取sessionStorage里的状态信息
    if (sessionStorage.getItem("store")) {
      this.$store.replaceState(
        Object.assign(
          {},
          this.$store.state,
          JSON.parse(sessionStorage.getItem("store")),
        ),
      );
    }
  },
  mounted() {},
  methods: {
    // 记录token到本地存储
    recordToken(token) {
      localStorage.setItem("token", token);
    },
  },
};
</script>

<style lang="css">
/* .el-tooltip__popper {
  max-width: 50%;
} */
</style>

<style lang="less">
@import url("common/zcm-main.css");
@import url("common/iconfont.css");

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  // color: white;
}

html,
body,
#app {
  width: 100%;
  height: 100%;
  font-family: "Microsoft YaHei", Arial, Helvetica, sans-serif, "宋体";
}
</style>
